import React, { useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { NavLink, useNavigate } from 'react-router';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import Pagination from '../../../components/base/Pagination/Pagination';
import { zoneColumns } from './zoneColumns';
import ExportDialog from './ExportDialog';
import ImportDialog from './ImportDialog';
import { dateFormatter } from '../../../utils/formatters';

export default function ZoneList(props) {
  const {
    handleCreate = () => {},
    handleEdit = () => {},
    handleDelete = () => {},
    handleSelect = () => {},
    handleImport = () => {},
    handleExport = () => {},
    loadData = () => {},
    selected = null,
    zoneListMeta = {},
    zoneList = [],
    control,
  } = props;
  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const handleClose = item => {
    setShowImport(false);
    setShowExport(false);
  };

  return (
    <div className="list-columns card py-3">
      <div className="list-header px-3">
        <div className="fs-5 fw-semibold ">{formatMessage({ id: 'menu.zones' })}</div>
        <Button className="small-button ms-auto" variant="second" onClick={() => setShowImport(true)}>
          <Icons icon="journal-arrow-down" />
        </Button>
        <Button className="small-button ms-2" variant="second" onClick={handleExport}>
          <Icons icon="journal-arrow-up" />
        </Button>
        <Button className="small-button ms-2" variant="second" onClick={handleCreate}>
          <Icons customIcon icon="plus" />
        </Button>
      </div>
      <div className="filter-row px-3 mt-3">
        <FieldDTO
          control={control}
          component={TextInput}
          dtoObject={{
            name: 'search',
            type: String,
            labelKey: 'search',
          }}
          className="no-border"
          inputBefore={(
            <div className="search-wrapper">
              <Icons customIcon className="search" width={24} height={24} icon="search" />
            </div>
          )}
        />
      </div>
      <div className="list-content-wrapper">
        <div className="list-content-body custom-scroll-theme list-group list-group-flush border-bottom">
          {zoneList.map((zone, key) => (
            <div
              key={key}
              className={classNames('list-group-item list-group-item-action py-3 lh-sm pointer', { active: zone.id === selected })}
              onClick={handleSelect(zone)}
            >
              <div className="d-flex w-100 align-items-center justify-content-between">
                <div className="d-flex flex-row col-xxl-12">
                  <div className="list-item-name"><strong className="mb-1">{zone?.name || ''}</strong></div>
                  <div className="zone-button-block d-flex flex-row ms-auto">
                    <div className="zone-capacity"><small>{zone?.capacity || ''}</small></div>
                    <Button className="small-button" variant="second" onClick={() => window.open(`/zones/history?zone_id=${zone.id}`, '_blank')}>
                      <Icons icon="info-lg" />
                    </Button>
                    <Button className="small-button ms-1" variant="second" onClick={handleEdit(zone)}>
                      <Icons icon="pencil" />
                    </Button>
                    <Button className="small-button red-hover ms-1" variant="second" onClick={handleDelete(zone)}>
                      <Icons icon="trash" />
                    </Button>
                  </div>
                </div>
              </div>
              <div className="w-100 mb-1 mt-1 small">{zone?.description || ''}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="list-footer px-3">
        <Pagination meta={zoneListMeta} list={zoneList} handleChangeMeta={loadData} />
      </div>
      {showExport ? <ExportDialog onClose={handleClose} loadData={loadData} handleExport={handleExport} columns={zoneColumns} /> : null}
      {showImport ? <ImportDialog onClose={handleClose} loadData={loadData} handleImport={handleImport} /> : null}
    </div>
  );
}
